// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { firmStats } from "~/util/review";
import { _ } from "~/i18n";

/**
 * @class TableReservation
 * @augments SMap.Detail.Content
 * @private
 */
export default class TableReservation extends Content {
	_build() {
		this._dom.container.classList.add("content-table-reservation");

		let link = Mapy.Util.node("a", {
			href: this._data,
			target: "_blank"
		});
		link.textContent = _("detail.content.tableReservation");
		// analytika
		link.addEventListener("pointerdown", () => {
			firmStats("firmy-vizitka-akce", this._options, { placeId: 2, typeId: 18 });
		});
		this._dom.container.appendChild(link);
	}
}
